// extracted by mini-css-extract-plugin
export default {"paneset":"paneset---dUIpZ","nested":"nested---xWiP2","static":"static---_L_Is"};